import ColumnsSvg from '../assets/columns (2).svg';

export function ColumnsIcon({ className = '' }: { className?: string }) {
    return <img className={className} src={ColumnsSvg} alt='Columns' />;
}
